import { createContext } from "react";

const AppContext = createContext({
  clicks: [null, () => {}],
  image: [null, () => {}],
  maskImg: [null, () => {}],
});

export default AppContext;
